import path from 'path'
import inspector from 'inspector'
import colors from 'colors'
import inquirer from 'inquirer'
import ncp from 'copy-paste'
import { clearTerminal } from './terminal-utils'

function waitForEnter (then) {
    console.log('Press ' + colors.bold('[ENTER]') + ' to continue')
    process.stdin.resume();
    process.stdin.once('data', function () {
        then()
    })
}

function inspectorServer () {
  return new Promise ((resolve, reject) => {
    const readyToResolve = resolve

    // we will also start an inspector
    inspector.open(9229, 'localhost')
    let inspectorURL = 'chrome-devtools://devtools/bundled/inspector.html?experiments=true&v8only=true&ws='
    inspectorURL+= '127.0.0.1:9229/'
    inspectorURL+= path.basename(inspector.url())
    // these are the current choices for using or storing the debigging URLs
    let choices = [
      `${colors.bold('Do not')} copy anything`,
      `Copy ${colors.bold('chrome url')} to clipboard`,
      `Copy ${colors.bold('socket url')} to clipboard`,
      new inquirer.Separator(),
      `${colors.bold('Show')} chrome url`,
      `${colors.bold('Show')} socket url`,
      new inquirer.Separator(),
      'Cancel/Abort'
    ]

    clearTerminal()
    // let's see what the user wants
    inquirer.prompt([{
      type: 'list',
      name: 'copyOrNot',
      pageSize: 20,
      message: `\nStarting in ${colors.italic('Developer Mode')}.\nThe ${colors.italic.bold('debugger')} is activated and you can debug your node server in an external graphical interface.\n`,
      choices
    }]).then(answers => {
      let answer = choices.indexOf(answers.copyOrNot)
      
      // console.log('1', process.cwd())
      // console.log('2', __dirname)
      // console.log('3', require.main.filename)
      // console.log('4', process.argv[0])
      // console.log('5', process.argv[1])

      switch (answer) {
        case 0: {
          // do not copy, just go on
          readyToResolve()
          break
        }
        case 1: {
          // copy the chrome inspector url
          ncp.copy(inspectorURL)
          // and wait for the user to open it, and hit enter
          waitForEnter(readyToResolve)
          break
        }
        case 2: {
          // copy the web socket url for the debigging protocol
          ncp.copy(inspector.url())
          // and wait for the user to open it, and hit enter
          waitForEnter(readyToResolve)
          break
        }
        case 4: {
          // show the chrome inspector url
          console.log('\n The chrome browser url is:\n', inspectorURL, '\n')
          // and wait for the user to open it, and hit enter
          waitForEnter(readyToResolve)
          break
        }
        case 5: {
          // show the web socket url for the debigging protocol
          console.log('\n The web socket url is:\n', inspector.url(), '\n')
          // and wait for the user to open it, and hit enter
          waitForEnter(readyToResolve)
          break
        }
        case 7: {
          // user gave up! Aborting
          console.log('\nInitialization aborted\n')
          process.exit(0)
          break
        }
      }
    })
  })
}

export default inspectorServer



// WEBPACK FOOTER //
// ./src/node-inspector-server.js